<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="footer-inner">
            <p>© 2013 - {{new Date().getFullYear()}} Altezza Travel</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {

}
</script>
